/* JRC store locator — Leaflet + OpenStreetMap, dealer data inlined by
   snippets/jrc-dealer-data.liquid. No API keys, no third-party app. */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-jrc-locator]');
    if (!root) return;

    var dataEl = root.querySelector('[data-jrc-dealer-data]');
    var listEl = root.querySelector('[data-jrc-list]');
    var mapEl = root.querySelector('[data-jrc-map]');
    var searchEl = root.querySelector('[data-jrc-search]');
    var countryEl = root.querySelector('[data-jrc-country]');
    var nearEl = root.querySelector('[data-jrc-near]');
    var countEl = root.querySelector('[data-jrc-count]');
    var statusEl = root.querySelector('[data-jrc-status]');

    var dealers;
    try {
      dealers = JSON.parse(dataEl.textContent).dealers;
    } catch (e) {
      if (statusEl) statusEl.textContent = 'Sorry — the dealer list could not be loaded. Please contact us and we will point you to your nearest stockist.';
      return;
    }
    dealers.forEach(function (d, i) { d._i = i; d._dist = null; });

    var esc = function (s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };
    var webHref = function (w) { return /^https?:\/\//i.test(w) ? w : 'https://' + w; };
    var webLabel = function (w) {
      return w.replace(/^https?:\/\//i, '').replace(/^www\./i, '').replace(/\/.*$/, '');
    };

    /* ---------- country filter ---------- */
    var counts = {};
    dealers.forEach(function (d) { counts[d.country] = (counts[d.country] || 0) + 1; });
    Object.keys(counts).sort().forEach(function (c) {
      var o = document.createElement('option');
      o.value = c;
      o.textContent = c + ' (' + counts[c] + ')';
      countryEl.appendChild(o);
    });

    /* ---------- map ---------- */
    var map = null;
    var cluster = null;
    var markers = [];
    var userMarker = null;
    var hasLeaflet = typeof window.L !== 'undefined';

    var pinIcon = null;
    if (hasLeaflet) {
      pinIcon = L.divIcon({
        className: 'jrc-sl-pin',
        html: '<svg viewBox="0 0 24 34" width="26" height="37" aria-hidden="true"><path d="M12 0C5.4 0 0 5.4 0 12c0 8.4 10.6 20.6 11.1 21.1a1.2 1.2 0 0 0 1.8 0C13.4 32.6 24 20.4 24 12 24 5.4 18.6 0 12 0z" fill="#121212"/><circle cx="12" cy="12" r="5" fill="#fff"/></svg>',
        iconSize: [26, 37],
        iconAnchor: [13, 36],
        popupAnchor: [0, -32]
      });

      map = L.map(mapEl, { scrollWheelZoom: false });
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors'
      }).addTo(map);
      /* scroll-wheel zoom only after the map is clicked, so the page scroll is not trapped */
      map.on('click focus', function () { map.scrollWheelZoom.enable(); });
      map.on('mouseout', function () { map.scrollWheelZoom.disable(); });

      var clusterOk = typeof L.markerClusterGroup === 'function';
      cluster = clusterOk
        ? L.markerClusterGroup({
            showCoverageOnHover: false,
            maxClusterRadius: 44,
            iconCreateFunction: function (c) {
              return L.divIcon({
                html: '<span>' + c.getChildCount() + '</span>',
                className: 'jrc-sl-cluster',
                iconSize: [36, 36]
              });
            }
          })
        : L.layerGroup();
      cluster.addTo(map);

      dealers.forEach(function (d) {
        var m = L.marker([d.lat, d.lng], { icon: pinIcon });
        m.bindPopup(popupHtml(d), { maxWidth: 280 });
        m.on('click', function () { highlightCard(d._i, false); });
        markers[d._i] = m;
      });
    } else {
      mapEl.classList.add('jrc-sl-map--off');
      mapEl.innerHTML = '<p class="jrc-sl-map-fallback">Map unavailable — the full dealer list is below.</p>';
    }

    function popupHtml(d) {
      var lines = [];
      lines.push('<strong class="jrc-sl-pop-name">' + esc(d.name) + '</strong>');
      var addr = [d.addr1, d.addr2, [d.city, d.zip].filter(Boolean).join(' '), [d.state, d.country].filter(Boolean).join(', ')]
        .filter(Boolean).map(esc).join('<br>');
      if (addr) lines.push('<span class="jrc-sl-pop-addr">' + addr + '</span>');
      var links = [];
      if (d.phone) links.push('<a href="tel:' + esc(d.phone.replace(/[^+\d]/g, '')) + '">' + esc(d.phone) + '</a>');
      if (d.web) links.push('<a href="' + esc(webHref(d.web)) + '" target="_blank" rel="noopener">' + esc(webLabel(d.web)) + '</a>');
      links.push('<a href="https://www.google.com/maps/dir/?api=1&destination=' + d.lat + ',' + d.lng + '" target="_blank" rel="noopener">Directions</a>');
      lines.push('<span class="jrc-sl-pop-links">' + links.join(' &middot; ') + '</span>');
      return '<div class="jrc-sl-pop">' + lines.join('') + '</div>';
    }

    /* ---------- list ---------- */
    function cardHtml(d) {
      var addr = [d.addr1, [d.city, d.zip].filter(Boolean).join(' ')].filter(Boolean).map(esc).join(', ');
      var h = '<button type="button" class="jrc-sl-card" data-jrc-card="' + d._i + '">';
      h += '<span class="jrc-sl-card-top"><span class="jrc-sl-card-name">' + esc(d.name) + '</span>';
      if (d._dist != null) h += '<span class="jrc-sl-card-dist">' + formatDist(d._dist) + '</span>';
      h += '</span>';
      if (addr) h += '<span class="jrc-sl-card-addr">' + addr + '</span>';
      h += '<span class="jrc-sl-card-country">' + esc(d.country) + '</span>';
      h += '</button>';
      return h;
    }
    function formatDist(km) {
      return km < 10 ? km.toFixed(1) + ' km' : Math.round(km) + ' km';
    }

    var current = dealers.slice();
    function render() {
      var q = (searchEl.value || '').trim().toLowerCase();
      var country = countryEl.value;
      current = dealers.filter(function (d) {
        if (country && d.country !== country) return false;
        if (!q) return true;
        return [d.name, d.city, d.country, d.zip, d.addr1, d.state].join(' ').toLowerCase().indexOf(q) !== -1;
      });
      if (current[0] && current[0]._dist != null) {
        current.sort(function (a, b) { return a._dist - b._dist; });
      }
      listEl.innerHTML = current.length
        ? current.map(cardHtml).join('')
        : '<p class="jrc-sl-empty">No dealers match your search.</p>';
      countEl.textContent = current.length === dealers.length
        ? dealers.length + ' dealers in ' + Object.keys(counts).length + ' countries'
        : current.length + ' of ' + dealers.length + ' dealers';

      if (map) {
        cluster.clearLayers();
        current.forEach(function (d) { cluster.addLayer(markers[d._i]); });
        fitTo(current);
      }
    }

    function fitTo(set) {
      if (!map || !set.length) return;
      var pts = set.map(function (d) { return [d.lat, d.lng]; });
      /* On the unfiltered view, frame the region where most dealers are
         (Europe) instead of a near-empty world map. */
      if (set.length === dealers.length) {
        var eu = set.filter(function (d) {
          return d.lat > 34 && d.lat < 62 && d.lng > -12 && d.lng < 26;
        });
        if (eu.length >= set.length / 2) pts = eu.map(function (d) { return [d.lat, d.lng]; });
      }
      map.fitBounds(L.latLngBounds(pts).pad(0.06), { maxZoom: 12 });
    }

    function highlightCard(i, scroll) {
      var prev = listEl.querySelector('.jrc-sl-card.is-active');
      if (prev) prev.classList.remove('is-active');
      var card = listEl.querySelector('[data-jrc-card="' + i + '"]');
      if (card) {
        card.classList.add('is-active');
        if (scroll !== false) card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    listEl.addEventListener('click', function (e) {
      var card = e.target.closest('[data-jrc-card]');
      if (!card) return;
      var i = parseInt(card.getAttribute('data-jrc-card'), 10);
      highlightCard(i, false);
      if (!map) return;
      var m = markers[i];
      if (typeof cluster.zoomToShowLayer === 'function') {
        cluster.zoomToShowLayer(m, function () { m.openPopup(); });
      } else {
        map.setView(m.getLatLng(), 13);
        m.openPopup();
      }
      if (window.matchMedia('(max-width: 989px)').matches) {
        mapEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    });

    searchEl.addEventListener('input', render);
    countryEl.addEventListener('change', render);

    /* ---------- near me ---------- */
    function haversine(a, b, c, d2) {
      var r = Math.PI / 180, R = 6371;
      var dLat = (c - a) * r, dLng = (d2 - b) * r;
      var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(a * r) * Math.cos(c * r) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * R * Math.asin(Math.sqrt(s));
    }
    nearEl.addEventListener('click', function () {
      if (!navigator.geolocation) {
        statusEl.textContent = 'Location is not available in this browser.';
        return;
      }
      nearEl.disabled = true;
      statusEl.textContent = 'Finding dealers near you…';
      navigator.geolocation.getCurrentPosition(function (pos) {
        nearEl.disabled = false;
        statusEl.textContent = '';
        var lat = pos.coords.latitude, lng = pos.coords.longitude;
        dealers.forEach(function (d) { d._dist = haversine(lat, lng, d.lat, d.lng); });
        countryEl.value = '';
        searchEl.value = '';
        render();
        if (map) {
          if (userMarker) userMarker.remove();
          userMarker = L.marker([lat, lng], {
            icon: L.divIcon({ className: 'jrc-sl-you', html: '<span></span>', iconSize: [18, 18], iconAnchor: [9, 9] }),
            interactive: false
          }).addTo(map);
          var nearest = current.slice(0, 5).map(function (d) { return [d.lat, d.lng]; });
          nearest.push([lat, lng]);
          map.fitBounds(L.latLngBounds(nearest).pad(0.2));
        }
      }, function () {
        nearEl.disabled = false;
        statusEl.textContent = 'We could not get your location — check your browser permissions, or search by town or country instead.';
      }, { timeout: 10000, maximumAge: 300000 });
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
